<template>
  <div class="nav-page">
    <div class="nav-left-container">
      <ul class="nav-list-container">
        <li class="nav-item-container hardware">
          <div @click="jump( 'hardwareList' )" class="routerLink">硬件分类</div>
          <div class="nav-card-container">
            <div class="nav-card-left-container">
              <ul class="product-nav-list-container">
                <li
                  class="product-nav-item-container"
                  v-for="( item , key ) in goodsTypeData"
                  :key="key"
                >
                  <p
                    class="nav-item-title-container"
                    @click="jump( 'hardwareList' , item.id )"
                  >{{ item.name }}</p>
                  <p class="nav-item-enumerate-container">
                    <span
                      class="item-enumerate"
                      :title="itemChild.title"
                      @click="jump( 'hardwareDetails' , itemChild.id )"
                      v-for="( itemChild , index  ) in item.childData"
                      :key="index"
                    >{{ itemChild.title }}</span>
                  </p>
                </li>
              </ul>
            </div>
            <div class="nav-card-right-container">
              <div class="nav-card-right-item-container">
                <div class="bottom-typeDetails-container">
                  <!-- <vue-scroll :ops="ops"> -->
                  <div class="nav-list">
                    <a>4G LTE网关</a>
                    <a>4G全网通</a>
                    <a>4G MQTT网关</a>
                    <a>Lora网关</a>
                    <a>串口服务器</a>
                  </div>
                  <ul class="typeDetails-list-container">
                    <li
                      class="typeDetails-item-container"
                      v-for="( item , key ) in listShowData"
                      :key="key"
                    >
                      <a href="javascript:;" @click="jump( 'hardwareDetails' , item.id )">
                        <p class="item-title">{{ item.title }}</p>
                        <img :src="item.image" alt class="item-img" />
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a
                        href="javascript:;"
                        class="product-link see-more"
                        @click="jump( 'hardwareList' , listShowId )"
                      >
                        <span class="product-name">查看更多</span>
                        <img src="../assets/img/common/chakangengduo.png" alt class="product-img" />
                      </a>
                    </li>
                  </ul>
                  <!-- </vue-scroll> -->
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item-container software">
          <div class="routerLink" @click="jump( 'shuzixiangcun' )">系统平台</div>
          <div class="nav-card-container">
            <div class="nav-card-left-container">
              <ul class="product-nav-list-container">
                 <li class="product-nav-item-container" data-id="3">
                  <img src="../assets/img/common/icon1.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">数字乡村</p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'shuzixiangcun' )">数字乡村综合服务平台</span>
                    <span class="item-enumerate" v-if="shownav" @click="jump( 'online_retailers' )">农村电商邻里拼</span>
                    <span class="item-enumerate" v-if="shownav" @click="jump( 'smartpensionsolutions' )">智慧养老</span>
                    
                  </p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" v-if="shownav" @click="jump( 'village_resources' )">乡村资源一张图</span>
                    <span class="item-enumerate" v-if="shownav" @click="jump( 'wuranzhili' )">土壤治理数字化</span>
                  </p>
                  
                </li>
                <li class="product-nav-item-container" data-id="1">
                   <img src="../assets/img/common/icon3.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">未来农场</p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'Integration_of_water_and_fertilizer' )">水肥一体化</span>
                    <span class="item-enumerate" @click="jump( 'Future_farm' )">植物工厂</span>
                    <span class="item-enumerate" @click="jump( 'Plant_factory' )">未来农场</span>                         
                  </p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'xiaojinxian' )">小金县智慧农业</span>      
                    <span class="item-enumerate" @click="jump( 'gongxiangtianyuan' )">新桐乡共享田园案例</span>                  
                  </p>
                </li>
                <li class="product-nav-item-container" data-id="0">
                  <img src="../assets/img/common/icon2.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">大棚农业</p>
                  <p class="nav-item-enumerate-container">
                   
                    <span class="item-enumerate" @click="jump( 'greenhouse' )">智慧农业大棚建设</span>
                    <span class="item-enumerate" @click="jump( 'intelligentAgriculture' )">基础版智慧农业</span>
                    <span class="item-enumerate" @click="jump( 'intelligentAgricultureall' )">人工智能版智慧农业</span>
              
                  </p>
                    <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'kzss' )">空中种植设施栽培</span> 
                    <span class="item-enumerate" @click="jump( 'zhihui2.5' )">智慧农业可视化</span>
                    <span class="item-enumerate" @click="jump( 'wuzhen' )">乌镇数字农业</span>
                    
                  </p>
                </li>
                <li class="product-nav-item-container" data-id="1">
                   <img src="../assets/img/common/icon3.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">大田农业</p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'high_standard_farmland' )">高标准农田建设方案</span>
                    <span class="item-enumerate" @click="jump( 'allShareAac' )">共享田园解决方案</span>
                    <span class="item-enumerate" @click="jump( 'nongyesuyuan' )">农业溯源解决方案</span>      
                    
                   
                    
                  </p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'pestMonitoring' )">虫情监测解决方案</span>
                    <span class="item-enumerate" @click="jump( 'farmingandagriculturalmaterials' )">农事农资解决方案</span>
                    <span class="item-enumerate" @click="jump( 'intelligentAgriculturexample' )">智能农业案例汇聚</span>
                  </p>
                  <p class="nav-item-enumerate-container"></p>
                   <p class="nav-item-enumerate-container">
                    <span class="item-enumerate"  style="width:100% !important;display:block" @click="jump( 'gaobiaozhun' )">桐庐旧县高标准农田示范区</span>
                  </p>
                  <p class="nav-item-enumerate-container"></p>
                  
                </li>

                <li class="product-nav-item-container" data-id="5">
                   <img src="../assets/img/common/icon4.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">数字渔场</p>

                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'digitalFishery' )">数字渔场解决方案</span>
                    <span class="item-enumerate" @click="jump( 'fishAndVeg' )">鱼菜共生解决方案</span>
                    <span class="item-enumerate" @click="jump( 'xunyu' )">鲟鱼养殖案例</span>
                    
                    <!-- <span
                      class="item-enumerate"
                      @click="jump( 'intelligentAgricultureall' )"
                    >人工智能版智慧农业</span> -->
                  </p>
                  <!-- <p class="nav-item-enumerate-container space-between-container">
                    <span class="item-enumerate" @click="jump( 'nongyesuyuan' )">农业溯源解决方案</span>
                    <span class="item-enumerate" @click="jump( 'shuzixiangcun' )">数字渔场解决方案</span>
                  </p>
                  <p class="nav-item-enumerate-container space-between-container">
                    <span class="item-enumerate" @click="jump( 'digitalFishery' )">数字渔场解决方案</span>
                    <span class="item-enumerate" @click="jump( 'pestMonitoring' )">虫情监测解决方案</span>
                  </p> -->
          
                </li>
                <li class="product-nav-item-container" data-id="2">
                   <img src="../assets/img/common/icon5.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">智慧养殖</p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'digitalpigraising' )">智慧养殖案例</span>
                    <span class="item-enumerate" @click="jump( 'digitalpigraising' )"></span>
                  </p>
                </li>
                <li class="product-nav-item-container" data-id="1">
                   <img src="../assets/img/common/icon3.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">数字茶园 </p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'xincangcha' )">新昌茶园&遂昌茶园</span>
                  </p>
                </li>
                <li class="product-nav-item-container" data-id="1">
                   <img src="../assets/img/common/icon3.png" alt class="icon-nav" />
                  <p class="nav-item-title-container">水位监测 </p>
                  <p class="nav-item-enumerate-container">
                    <span class="item-enumerate" @click="jump( 'water_level_detection' )">水位监测 </span>                
                  </p>
                </li>
               
              </ul>
            </div>
            <div class="nav-card-right-container">
              <div class="nav-card-right-item-container" data-id="0">
                <div class="top-typeLabel-container">
                  <ul class="typeLabel-list-container">
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">基础版智慧农业</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgricultureall' )">人工智能版智慧农业</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'zhihui2.5' )">智慧农业可视化</a>
                    </li>
                  
                  </ul>
                </div>
                <div class="bottom-typeDetails-container">
                  <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg2.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">基础版智慧农业</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculturexample' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg10.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">人工智能版智慧农业</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="nav-card-right-item-container" data-id="1">
                <div class="top-typeLabel-container">
                  <ul class="typeLabel-list-container">
                    <li class="typeLabel-item-container">
                      <!-- <a href="javascript:;" @click="jump( 'industrial_interconnection' )">工业互联</a> -->
                      <a href="javascript:;" @click="jump( 'nongyesuyuan' )">农业溯源解决方案</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'pestMonitoring' )">虫情监测解决方案</a>
                    </li>
                    <!-- <li class="typeLabel-item-container">
                        <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">智慧农业</a>
                    </li>-->
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculturexample' )">智能农业案例汇聚</a>
                    </li>
                    <!-- <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'smartToilet' )">智慧公厕</a>
                    </li> -->
                  </ul>
                </div>
                <div class="bottom-typeDetails-container">
                   <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg2.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">基础版智慧农业</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculturexample' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg10.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">人工智能版智慧农业</p>
                      </a>
                    </li>
                  </ul>
                  <!-- <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'jijiagong' )">
                        <img src="../assets/img/software/default_img3.png" alt class="item-img" />
                        <p class="title">产线机床工业互联</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'industrial_interconnection2' )">
                        <img src="../assets/img/software/default_img4.png" alt class="item-img" />
                        <p class="title">品控检测工业互联</p>
                      </a>
                    </li>
                  </ul> -->
                </div>
              </div>
              <div class="nav-card-right-item-container" data-id="5">
                <div class="top-typeLabel-container">
                  <ul class="typeLabel-list-container">
                    <li class="typeLabel-item-container">
                      <!-- <a href="javascript:;" @click="jump( 'industrial_interconnection' )">工业互联</a> -->
                      <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">基础版智慧农业</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgricultureall' )">人工智能版智慧农业</a>
                    </li>

                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'zhihui2.5' )">智慧农业可视化</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'nongyesuyuan' )">农业溯源解决方案</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'shuzixiangcun' )">数字乡村解决方案</a>
                    </li>

                    <li class="typeLabel-item-container">
                      <a
                        href="javascript:;"
                        @click="jump( 'intelligentAgriculturexample' )"
                      >智能农业案例汇聚</a>
                    </li>
                  </ul>
                </div>
                <div class="bottom-typeDetails-container">
                  <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg2.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">基础版智慧农业</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculturexample' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg10.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">人工智能版智慧农业</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="nav-card-right-item-container" data-id="2">
                <div class="top-typeLabel-container">
                  <ul class="typeLabel-list-container">
                    <!-- <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'lithiumBatteryMES' )">锂电池MES系统</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'factoryFireControl' )">厂区消防</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'viewChemicalIndustry' )">视觉化工智慧平台</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentWorkOrderERP' )">智能工单ERP</a>
                    </li> -->
                    <!-- <li class="typeLabel-item-container">
                        <a href="javascript:;" @click="jump( 'intelligentIndustry' )">智能工业</a>
                    </li>-->
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'farming' )">智慧养殖案例</a>
                    </li>
                    <!-- <li class="typeLabel-item-container">
                        <a href="javascript:;">智慧物流</a>
                    </li>-->
                    <!-- <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'microseismic' )">微震监测平台</a>
                    </li> -->
                    <!-- <li class="typeLabel-item-container">
                        <a href="javascript:;" @click="jump( 'jijiagong' )">机加工互联MES</a>
                    </li>-->
                    <!-- <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'mingyue' )">明月眼镜WMS</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'huanjing' )">环保大数据IOT</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentIndustry2' )">智能工业</a>
                    </li> -->
                  </ul>
                </div>
                <div class="bottom-typeDetails-container">
                   <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg2.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">基础版智慧农业</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculturexample' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg10.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">人工智能版智慧农业</p>
                      </a>
                    </li>
                  </ul>
                  <!-- <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentIndustry2' )">
                        <img src="../assets/img/software/default_img5.png" alt class="item-img" />
                        <p class="title">智能工业</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'jijiagong' )">
                        <img src="../assets/img/software/default_img6.png" alt class="item-img" />
                        <p class="title">机加工互联</p>
                      </a>
                    </li>
                  </ul> -->
                </div>
              </div>
              <div class="nav-card-right-item-container" data-id="3">
                <div class="top-typeLabel-container">
                  <ul class="typeLabel-list-container">
  
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'shuzixiangcun' )">数字乡村解决方案</a>
                    </li>
                    <!-- <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'chintMeter' )">正泰电表</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentMotor' )">智能电机</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'apartmentMeter' )">公寓电表</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'smartCampus' )">智慧校园</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'dahezi' )">智能洗车IOT</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'EEEManagement' )">能效管理</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'jijiagongApp' )">机加工互联</a>
                    </li>
                    <li class="typeLabel-item-container">
                      <a href="javascript:;" @click="jump( 'beautiful' )">美容仪器</a>
                    </li> -->
                  </ul>
                </div>
                <div class="bottom-typeDetails-container">
                   <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculture' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg2.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">基础版智慧农业</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'intelligentAgriculturexample' )">
                        <img
                          src="../assets/img/caseDetails/intelligentAgricultureall/imgbg10.png"
                          alt
                          class="item-img"
                        />
                        <p class="title">人工智能版智慧农业</p>
                      </a>
                    </li>
                  </ul>
                  <!-- <ul class="typeDetails-list-container">
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'industrialIntelligenceUnion' )">
                        <img src="../assets/img/software/default_img7.png" alt class="item-img" />
                        <p class="title">数字乡村</p>
                      </a>
                    </li>
                    <li class="typeDetails-item-container">
                      <a href="javascript:;" @click="jump( 'chintMeter' )">
                        <img src="../assets/img/software/default_img8.png" alt class="item-img" />
                        <p class="title">正泰电表</p>
                      </a>
                    </li>
                  </ul> -->
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item-container"  v-if="shownav">
          <!-- <a href="http://www.100badou.com/forum/index.html" target="_blank" class="routerLink"> -->
          <a href="http://www.乡村互联.com/forum/" target="_blank" class="routerLink">数字乡村社区</a>
        </li>
        
        <li class="nav-item-container">
          <div class="routerLink" @click="jump( 'zhanting' )">百倍云展厅</div>
        </li>
        <!-- <li class="nav-item-container"  v-if="shownav">
          <div class="routerLink" @click="jump( 'campany' )">代理合作</div>
        </li> -->
        <li class="nav-item-container">
          <div class="routerLink" @click="jump( 'aboutUs' )">关于我们</div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "navs",
  data() {
    return {
      shownav:false,
      ops: {
        vuescroll: {
          mode: "native",
          sizeStrategy: "percent",
          detectResize: true,
        },
        scrollPanel: {
          initialScrollY: false,
          initialScrollX: false,
          scrollingX: true,
          scrollingY: true,
          speed: 300,
          easing: undefined,
          verticalNativeBarPos: "right",
        },
        rail: {
          background: "#01a99a",
          opacity: 0,
          size: "6px",
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: "2px",
          keepShow: false,
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: false,
          keepShow: false,
          background: "#c1c1c1",
          opacity: 1,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: false,
          size: "6px",
          disable: false,
        },
      },
      goodsTypeData: [
        {
          id: "",
          name: "边缘计算",
          childData: [], // 子分类 ， 2个
          childAllData: [], // 所有的子分类，9个
        },
        {
          id: "",
          name: "普通网关",
          childData: [], // 子分类 ， 2个
          childAllData: [], // 所有的子分类，9个
        },
        // {
        //   id: "",
        //   name: "工业产线",
        //   childData: [], // 子分类 ， 2个
        //   childAllData: [], // 所有的子分类，9个
        // },
        // {
        //   id: "",
        //   name: "消防能效",
        //   childData: [], // 子分类 ， 2个
        //   childAllData: [], // 所有的子分类，9个
        // },
        {
          id: "",
          name: "气象环境",
          childData: [], // 子分类 ， 2个
          childAllData: [], // 所有的子分类，9个
        },
        {
          id: "",
          name: "水质环境",
          childData: [], // 子分类 ， 2个
          childAllData: [], // 所有的子分类，9个
        },
        {
          id: "",
          name: "农产林业",
          childData: [], // 子分类 ， 2个
          childAllData: [], // 所有的子分类，9个
        },
        // {
        //   id: "",
        //   name: "工地公厕",
        //   childData: [], // 子分类 ， 2个
        //   childAllData: [], // 所有的子分类，9个
        // },
        {
          id: "",
          name: "农业设备",
          childData: [], // 子分类 ， 2个
          childAllData: [], // 所有的子分类，9个
        },
      ], // 分类数据
      listShowData: [], // 硬件列表,右侧要显示的数据
      listShowId: "", // 当前显示的列表数据的分类id
      timer: "", // 定时器
      pageNum: 1, // 页数
      pageSize: 999999999, // 条数  直接加载所有的
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.changetitle()
    let that = this;
    $(document).on("mouseenter", ".nav-item-container", function () {
      $(this).children(".nav-card-container").show();
      $(this).find(".routerLink").addClass("ishover");
      $(this).find(".nav-card-right-container").hide();
    });

    $(document).on("mouseleave", ".nav-item-container", function () {
      $(this).children(".nav-card-container").hide();
      $(this).find(".routerLink").removeClass("ishover");

      $(this).find(".nav-item-title-container").removeClass("ishover"); // 取消左侧的选中
    });

    // 硬件
    $(document).on(
      "mouseenter",
      ".hardware .product-nav-item-container",
      function () {
        let index = $(this).index();
        //console.log(index)
        if (index == "1") {
          $(".nav-list").show();
        } else {
          $(".nav-list").hide();
        }
        that.listShowData = that.goodsTypeData[index].childAllData
          ? that.goodsTypeData[index].childAllData
          : []; // 获取对应的数组数据,显示出来
        that.listShowId = that.goodsTypeData[index].id
          ? that.goodsTypeData[index].id
          : ""; // 获取 当前显示的列表数据的分类id
        $(this)
          .find(".nav-item-title-container")
          .addClass("ishover")
          .parents(".product-nav-item-container")
          .siblings()
          .find(".nav-item-title-container")
          .removeClass("ishover");
        $(this)
          .parents(".nav-card-container")
          .children(".nav-card-right-container")
          .show();
        $(".hardware .nav-card-right-container")
          .children(`.nav-card-right-item-container:eq(${index})`)
          .show()
          .siblings()
          .hide();
      }
    );
    $(document).on("mouseenter", ".hardware .nav-list a", function () {
      that.listShowData = [];
      let index = $(this).index();
      // console.log(that.goodsTypeData[1].childAllData)
      // if(index == '1'){
      //   $(".nav-list").show()
      // }else{
      //    $(".nav-list").hide()
      // }
      for (var i = 0; i < that.goodsTypeData[1].childAllData.length; i++) {
        console.log(that.goodsTypeData[1].childAllData[i].secondLevel);
        if (that.goodsTypeData[1].childAllData[i].secondLevel == index) {
          that.listShowData.push(that.goodsTypeData[1].childAllData[i]);
        }
      }
      // console.log(that.listShowData)
      // that.listShowData = that.goodsTypeData[1].childAllData ? that.goodsTypeData[index].childAllData : [] // 获取对应的数组数据,显示出来
      // that.listShowId = that.goodsTypeData[index].id ? that.goodsTypeData[index].id : '' // 获取 当前显示的列表数据的分类id
      $(this).addClass("light-on").siblings().removeClass("light-on");
      // $(this).parents(".nav-card-container").children(".nav-card-right-container").show()
      // $(".hardware .nav-card-right-container").children(`.nav-card-right-item-container:eq(${ index })`).show().siblings().hide()
    });

    // 软件
    $(document).on(
      "mouseenter",
      ".software .product-nav-item-container",
      function () {
        return
        let index = $(this).attr("data-id"); // 获取自定义属性值
        $(this)
          .find(".nav-item-title-container")
          .addClass("ishover")
          .parents(".product-nav-item-container")
          .siblings()
          .find(".nav-item-title-container")
          .removeClass("ishover");
        $(this)
          .parents(".nav-card-container")
          .children(".nav-card-right-container")
          .show(); // 显示右侧卡片
        let rightItem = $(".software .nav-card-right-container").children(
          `.nav-card-right-item-container`
        ); // 获取右侧卡片
        for (let i = 0, len = rightItem.length; i < len; i++) {
          if ($(rightItem[i]).attr("data-id") == index) {
            $(rightItem[i]).show().siblings().hide(); // 和左侧选项卡对应的右侧卡片显示,其他隐藏
            //  $(this).parents(".product-nav-list-container").height( $( rightItem[i] ).height() - 57 ) // 获取右侧高度,给左侧
          }
        }
      }
    );
  },
  methods: {
    init() {
      this.getGoodsType();
    },
    changetitle(){//http://www.100byun.com  http://100byun.com使用这个域名访问官网时，底部的备案信息需要更换下，其它访问方式时，底部备案信息还是跟当前一样不变
    var url = window.location.href
     this.shownav = true
    // if(url.split("/#/")[0] == "http://www.100byun.com"||url.split("/#/")[0] == "http://100byun.com"){
    //   this.shownav = false
    // }else{
    //   this.shownav = true
        
    // }
    },
    jump(pathName, id) {
      if (id) {
        this.$router.push({
          name: pathName,
          query: {
            id: id,
          },
        });
      } else {
        this.$router.push({
          name: pathName,
        });
      }
    },
    jumpParams(pathName, id) {
      // 使用 params 传值
      if (id) {
        this.$router.push({
          name: pathName,
          params: {
            id: id,
          },
        });
      } else {
        this.$router.push({
          name: pathName,
        });
      }
    },

    getGoodsType() {
      // 获取商品分类
      this.$api.hardware.getGoodsType().then((res) => {
        if (res.code == 200) {
          let data = res.data;
          // 下面的循环是为了,获取数据库中的id,防止id发生变化
          for (let i = 0, len = data.length; i < len; i++) {
            for (let j = 0, leng = this.goodsTypeData.length; j < leng; j++) {
              if (this.goodsTypeData[j].name == data[i].name) {
                this.goodsTypeData[j].id = data[i].id;
              }
            }
          }
          this.getChildData();
        }
      });
    },

    getChildData() {
      let index = 0;
      let len = this.goodsTypeData.length;
      this.timer = setInterval(() => {
        let id = this.goodsTypeData[index].id;
        this.getGoodsInfoListCopy(index, id);
        index++;
        if (index == len) {
          clearInterval(this.timer);
        }
      }, 20);
    },

    getGoodsInfoListCopy(index, id) {
      this.$api.hardware
        .getGoodsInfoList("", this.pageNum, this.pageSize, id)
        .then((res) => {
          if (res.code == 200) {
            let dataSplice = [].concat(res.data);
            let data2 = [].concat(res.data);

            let data = dataSplice.splice(0, 2);
            let jsonData = data.map((item) => {
              return {
                id: item.id,
                title: item.title,
              };
            });
            let jsonAllData = data2.map((item) => {
              return {
                id: item.id,
                title: item.title,
                secondLevel: item.secondLevel,
                image: item.image.split(",")[0],
              };
            });
            this.goodsTypeData[index].childData.push(...jsonData);
            this.goodsTypeData[index].childAllData.push(...jsonAllData);
          }
        });
    },
  },
};
</script>

<style>
.nav-list {
  height: 52px;
  line-height: 40px;
  padding: 5px;
  box-sizing: border-box;
}
.nav-list a {
  color: #333;
  font-size: 14px;
  width: 20%;
  float: left;
  text-align: center;
}
.light-on {
  color: #4962f9 !important;
  border-bottom: 1px solid #4962f9;
}
</style>
